import { Plugin, PluginKey, Selection, TextSelection } from 'prosemirror-state'
import { MAIN_COLUMN_CONTAINER_ID, MAIN_LEFT_COLUMN_ID } from 'screens/ProseEdit/Constants'
import { clampCoordToRect } from 'utils/coordUtils'

export const CaretOnClickOutsidePluginKey = new PluginKey('CaretOnClickOutside')

/**
 * This plugin allows the user to click outside the editor (e.g. in the left margin) to move the
 * caret, as though they had clicked inside the editor at the nearest valid position closest to
 * where they clicked.
 */
export const CaretOnClickOutside = new Plugin({
  key: CaretOnClickOutsidePluginKey,
  view: (view) => {
    const handleClick = (event: MouseEvent) => {
      if (view.hasFocus()) return
      if (
        !(
          event.target instanceof HTMLElement &&
          [MAIN_LEFT_COLUMN_ID, MAIN_COLUMN_CONTAINER_ID].includes(event.target.id)
        )
      ) {
        return
      }
      const viewDomRect = view.dom.getBoundingClientRect()
      const clampedCoord = clampCoordToRect([event.clientX, event.clientY], viewDomRect)
      const clampedPos = view.posAtCoords({ left: clampedCoord[0], top: clampedCoord[1] })
      if (!clampedPos) return
      const foundCursor = Selection.findFrom(
        view.state.doc.resolve(clampedPos.pos),
        event.clientX < clampedCoord[0] ? 1 : -1,
        true,
      )
      if (!foundCursor) return
      view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, foundCursor.from)))
      view.focus()
    }

    document.getElementById(MAIN_COLUMN_CONTAINER_ID)?.addEventListener('click', handleClick)
    return {
      destroy() {
        document.getElementById(MAIN_COLUMN_CONTAINER_ID)?.removeEventListener('click', handleClick)
      },
    }
  },
})
